<template>
  <kst-form no-bezel class="block">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
        :urlParams="urlParams"
      />
    </template>
  </kst-form>
</template>

<script>
import Catalog from "../DlvCatalog.js";
import Model from "../DlvModel.js";

export default {
  props: {
    invoiceId: Number
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [Catalog.SOID.Param]: this.invoiceId
      });
    }
  }
}
</script>